// extracted by mini-css-extract-plugin
export default {"content":"U0p7KSDUACbelxN8ZEgL","placeHolderShimmer":"VqZHGo2PD3kCqqABf3K2"};